<template>
	<div>
		<div class="level action mb-0">
			<div class="level-left">
				<div class="level-item">
					<month-selector @change-year="onYearSelectChange" @change-month="onMonthSelectChange" @click-previous-month="onMonthPreviousButtonClick" @click-next-month="onMonthNextButtonClick"></month-selector>
				</div>
			</div>

			<div class="level-right">
				<div class="level-item action-buttons">
					<b-button type="is-success" @click="onNewButtonClick">新規作成</b-button>
					<b-upload class="ml-20" v-model="csvFile" @input="onCsvFileChange">
						<a class="button is-info">
							<span>CSVインポート</span>
						</a>
					</b-upload>
					<b-button class="ml-20" type="is-info" @click="onExportButtonClick">エクスポート</b-button>
				</div>
			</div>
		</div>

		<card class="is-card-table has-pagination has-table-borderless has-bottom-left-hidden" title="" icon="">
			<schedule-table-toolbar slot="toolbar" :staffs="staffs" :shops="shops" @search-button-click="onSearchButtonClick"/>
			<schedule-table :data="data" :isLoading="isLoading" @schedule-edit-buton-click="onScheduleEditButtonClick" @schedule-delete-buton-click="onScheduleDeleteButtonClick"/>
		</card>
		<b-modal :active.sync="isComponentModalActive" :width="700">
			<schedule-modal :id="editId" :year="year" :month="month" @schedule-update="onScheduleUpdate"></schedule-modal>
		</b-modal>
		<b-modal :active.sync="isScheculeImportErrorModalActive" :width="700">
			<schedule-import-error-modal :body="importErrorMsg"></schedule-import-error-modal>
		</b-modal>
	</div>
</template>

<script>
import Card from "@/components/Card";
import ScheduleTable from "@/components/ScheduleTable";
import ScheduleModal from "@/components/ScheduleModal";
import ScheduleImportErrorModal from "@/components/ScheduleImportErrorModal";
import ScheduleTableToolbar from "@/components/ScheduleTableToolbar";
import MonthSelector from "@/components/MonthSelector";
import qs from 'qs';
import moment from 'moment';

export default {
	name: 'schedule',
	components: {
		Card,
		ScheduleTable,
		ScheduleTableToolbar,
		ScheduleModal,
		ScheduleImportErrorModal,
		MonthSelector,
	},
	data() {
		return {
			data: [],
			isLoading: false,
			year: '',
			month: '',
			isComponentModalActive: false,
			isScheculeImportErrorModalActive: false,
			importErrorMsg: '',
			editId: '',
			csvFile: null,
			staffId: '',
			shopId: '',
			staffs: [],
			shops: [],
		}
	},
	created() {
		this.year = moment().format('YYYY').toString();
		this.endYear = parseInt(moment().format('YYYY')) + 1;
		for (let i = this.startYear; i <= this.endYear; i++) {
			this.years.push(i);
		}
		this.month = moment().format('M').toString();
	},
	mounted() {
		this.init();
		this.$store.commit('basic', {
			key: 'titleBarTitleStack',
			value: ['シフト管理']
		});
	},
	computed: {
	},
	methods: {
		onCsvFileChange: function() {
			this.$utils.log('onCsvFileChange');
			if (this.$utils.extractFileExtension(this.csvFile.name) !== 'csv') {
				alert('CSVファイルを選択してください');
				return false;
			}

			if (!window.confirm('当月のシフトはすべて上書きされます。シフトに紐づく実績データも削除されます。よろしいですか？')) {
				return false;
			}

			var reader = new FileReader();
			reader.onload = (e) => {
				this.uploadCsv(e.target.result);
			};
			reader.readAsDataURL(this.csvFile);
		},
		uploadCsv: async function(file) {
			let loading = this.$loading.open();

			let data = {
				"file": file,
				"year": this.year,
				"month": this.month,
			}
			this.$utils.log(data);

			let ep = 'works/import';
			this.$utils.log(ep);

			try {
				let res = await this.$api.post(ep, data, true);
				this.$utils.log(res);
				this.getData();
			} catch (error) {
				this.$utils.log(error);
				this.$utils.log(error.response.data.message);
				this.importErrorMsg = error.response.data.message;
				this.isScheculeImportErrorModalActive = true;
			} finally {
				this.csvFile = null;
				loading.close();
			}
		},
		onScheduleUpdate: function() {
			this.$utils.log('onScheduleUpdate');
			this.getData();
		},
		openModal: function(id = '') {
			this.$utils.log('openModal');
			this.editId = id;
			this.isComponentModalActive = true;
		},
		onNewButtonClick: function() {
			this.openModal();
		},
		onScheduleEditButtonClick: function(id) {
			this.openModal(id);
		},
		onExportButtonClick: async function() {
			let loading = this.$loading.open();

			let ep = `works/export?year=${this.year}&month=${this.month}`;
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				this.$utils.log(res);
				this.downloadCSV(res.data);
			} catch (error) {
				this.$utils.log(error);
				alert(error.response.data.message);
			} finally {
				loading.close();
			}
		},
		downloadCSV: function(data) {
			let fileName = `export_${this.year}${this.$utils.zeroPadding(this.month,2)}.csv`;
			this.$utils.downloadCSV(data, this.year, this.month, fileName);
		},
		onScheduleDeleteButtonClick: async function(id) {
			if (!window.confirm('シフトに紐づく実績データも削除されます。よろしいですか？')) {
				return false;
			}

			let loading = this.$loading.open();
			let ep = 'works/delete';
			this.$utils.log(ep);

			try {
				let res = await this.$api.post(ep, { "id": id }, true);
				this.$utils.log(res);
				this.data.some(function(v, i){
					if (v.id === id) this.data.splice(i, 1);
				}, this);
			} catch (error) {
				this.$utils.log(error);
				this.$utils.toastError(error.response.data.message);
			} finally {
				loading.close();
			}
		},
		getMonth: function(year, month) {
			return moment(`${year}-${this.$utils.zeroPadding(month, 2)}-01`);
		},
		getCurrentMonth: function() {
			return this.getMonth(this.year, this.month);
		},
		onYearSelectChange: function(year) {
			this.year = year;
			this.getData();
		},
		onMonthSelectChange: function(month) {
			this.month = month;
			this.getData();
		},
		onMonthPreviousButtonClick: function(year, month) {
			this.year = year;
			this.month = month;
			this.getData();
		},
		onMonthNextButtonClick: function(year, month) {
			this.year = year;
			this.month = month;
			this.getData();
		},
		init: function() {
			this.getData();
		},
		getData: async function() {
			this.isLoading = true;
			let data = {
				"year": this.year,
				"month": this.month,
				"staff_id": this.staffId,
				"shop_id": this.shopId,
			};
			this.$utils.log(data);

			let ep = 'works?' + qs.stringify(data);
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				this.$utils.log(res);
				if (!res.data.list) {
					this.data = [];
				} else {
					this.data = res.data.list;
				}
				this.totalNum = this.data.length;
				this.staffs = res.data.staffs;
				this.shops = res.data.shops;
			} catch (error) {
				this.$utils.log(error);
				this.$utils.toastError(error.response.data.message);
			} finally {
				this.isLoading = false;
			}
		},
		onSearchButtonClick: function(staffId, shopId, date) {
			this.$utils.log('onSearchButtonClick');
			this.staffId = staffId;
			this.shopId = shopId;
			this.getData();
		},
	},
}
</script>

<style scoped>

</style>
